export default __webpack_public_path__ + "static/media/star-buck-via.2ba39eed.jpg";